﻿import { View } from 'ckeditor5';

function createInfoView(locale) {
    const view = new View(locale);

    view.set({
        'character': null,
        'name': null
    });

    view.bind('code').to(view, 'character', characterToUnicodeString);

    view.setTemplate({
        tag: 'div',
        children: [
            {
                tag: 'span',
                attributes: {
                    class: ['ck-character-info__name']
                },
                children: [
                    {
                        // Note: Zero-Width space to prevent vertical collapsing of name is not set
                        text: view.bindTemplate.to('name', name => name ? name : '\u200B')
                    }
                ]
            },
            {
                tag: 'span',
                attributes: {
                    class: ['ck-character-info__code']
                },
                children: [
                    {
                        text: view.bindTemplate.to('code')
                    }
                ]
            }
        ],
        attributes: {
            class: ['ck', 'ck-character-info']
        }
    });

    return view;
}

function characterToUnicodeString(character) {
    if (character === null) {
        return '';
    }

    // code point indexes:
    // [0, 2]: first symbol
    // [3]: ZWJ (zero-width joiner) mostly
    // [4, 6]: second symbol
    // example: https://emojipedia.org/de/auge-in-sprechblase#technical

    // check if the character contains a ZWJ
    if (character.codePointAt(3) === 8205) {
        return [0, 2, 3, 4, 6].map(codePointIndex => {
            let codePoint = character.codePointAt(codePointIndex);
            if (codePoint) {
                return 'U+' + codePoint.toString(16).padStart('0', 4);
            }

            return undefined;
        }).join(' ');
    }
    else {
        return [0, 2].map(codePointIndex => {
            let codePoint = character.codePointAt(codePointIndex);
            if (codePoint) {
                return 'U+' + codePoint.toString(16).padStart('0', 4);
            }

            return undefined;
        }).join(' ');
    }
}

export { createInfoView };
